module.exports = __webpack_public_path__ + "media/nunitosans/NunitoSans-Bold-e84e70a0.woff2";